export default {
	namespaced: false,
	state: {
		access_token: '',
		refresh_token: '',
		user: {
			name: '',
			email: '',
			role: '',
		},
	},
	getters: {
		getToken: state => state.access_token,
		getUser: state => state.user,
	},
	mutations: {
		storeToken(state, { access_token, refresh_token, email, name, role }) {
			state.access_token = access_token
			state.refresh_token = refresh_token
			state.user.email = email
			state.user.name = name
			state.user.role = role
		},
		logoutUser(state) {
			state.token = null
		},
	},
	actions: {
		setLoginData({ commit }, data) {
			commit('storeLoginData', data)
		},
	},
}
